import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

import type { ConsoleConfig } from '../config.js';
import { scopesFor } from './scopes.js';

/** Where Zitadel sends the browser back to; registered for this host (ADR-0084). */
export const CALLBACK_PATH = '/auth/callback';

/**
 * Authorization Code with PKCE on Zitadel's hosted page (ADR-0066), through `oidc-client-ts`.
 *
 * The tokens live in session storage: closing the tab ends the session, and nothing outlives the
 * browser window in local storage. The refresh token from `offline_access` renews the access token
 * in the background before it expires.
 */
export function createUserManager(config: ConsoleConfig, origin = window.location.origin) {
  return new UserManager({
    authority: config.issuer,
    client_id: config.clientId,
    redirect_uri: `${origin}${CALLBACK_PATH}`,
    post_logout_redirect_uri: `${origin}/`,
    response_type: 'code',
    scope: scopesFor(config.projectId),
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
    stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
    automaticSilentRenew: true,
    // Zitadel leaves profile and email out of the id_token whenever it issues an access token
    // (unless the application asserts them), so the person's name comes from userinfo.
    loadUserInfo: true,
  });
}

/** What the console carries through a sign-in round trip: where to land afterwards. */
export interface SignInState {
  returnTo: string;
}
